module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Announcement_2.be618c47.png";